<template>
  <span>
    <v-layout
        v-if="loading"
        justify-center
        align-center
        class="loading-indicator"
    >
      <v-progress-circular
          indeterminate
          :size="70"
          :width="7"
      />
    </v-layout>
    <v-card
        class="main-card"
    >
      <v-card-title>
        <p class="text-h5">Настройки аккаунта</p>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text>
        <v-text-field v-model="account_data.name" label="Наименование аккаунта"></v-text-field>
        <v-text-field v-model="account_data.external_notify_email" label="Email сбыт"></v-text-field>
        <v-text-field v-model="account_data.support_email" label="Email поддержки"></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-btn
            v-if="isEdited"
            color="success"
            class="mr-4"
            @click="save"
        >
              Сохранить
            </v-btn>
          <v-btn v-if="isEdited"
              class="mr-4"
              @click="cancel"
          >
              Отмена
            </v-btn>
      </v-card-actions>
    </v-card>
  </span>
</template>

<script>
export default {
  name: 'AccountSettings',
  data () {
    return {
      loading: false,
      firstLoading: true,
      currentUser: {},
      account_data: {},
      isEdited: false
    }
  },
  watch: {
    account_data: {
      handler () {
        this.isEdited = true
      },
      deep: true
    }
  },
  mounted () {
    this.axios.get(`/api/users/me/`).then((response) => {
      this.currentUser = response.data
      this.getDetails()
    })
      .catch((err) => {
        console.log(err)
      })
  },
  methods: {
    getDetails () {
      this.axios.get(`/api/account/${this.currentUser.account_id}/`).then((response) => {
        this.account_data = response.data
        this.loading = false
        setTimeout(() => {
          this.isEdited = false
        }, 100)
      }).catch((err) => {
        console.log(err)
        this.loading = false
      })
    },
    save () {
      this.axios.patch(`/api/account/${this.currentUser.account_id}/`, this.account_data).then((response) => {
        this.account_data = response.data
        setTimeout(() => {
          this.isEdited = false
        }, 100)
        this.loading = false
      }).catch((err) => {
        console.log(err)
        this.loading = false
      })
    },
    cancel () {
      this.getDetails()
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/spa/account-settings/AccountSettings.vue